import BrowserService from '@/services/browserService'

export default (userId) => {
    window.dataLayer?.push({
        event: 'login',
        platform: BrowserService.platform(),
        sessionId: BrowserService.sessionId(),
        user_id: userId,
        _clear: true,
    })
}
